import { IBudget } from "../../../../models/budgetV2";
import { getStatusStyles, getBorderColor, getButtonBackgroundColor } from "../../utils/statusHelpers";
import { useIntl } from "react-intl";
import { formatDateTimeWithTimezone } from "../../../../utils/dateUtils";

interface BudgetKanbanCardProps {
  budget: IBudget;
  onViewVersions?: (budget: IBudget) => void;
}

const BudgetKanbanCard = ({ budget, onViewVersions }: BudgetKanbanCardProps) => {
  const intl = useIntl();

  const styles = getStatusStyles(budget.statusLabel || "");
  const borderColor = getBorderColor(budget.statusLabel || "");
  const buttonBackgroundColor = getButtonBackgroundColor(budget.statusLabel || "");

  return (
    <div className="p-[10px] !h-auto w-full bg-[#D0DAE2]">
      <div
        className={`w-full border rounded-lg p-4 flex flex-col justify-between ${styles.cardBg} ${styles.border} text-size-14 text-gray-800 cursor-pointer`}
        style={{
          height: "220px",
          borderWidth: "1.7px",
          borderColor: borderColor,
        }}
        onClick={() => onViewVersions?.(budget)}
      >
        <div>
          <div className="flex justify-between items-center mb-3">
            <span className="font-bold text-size-14 truncate">{intl.formatMessage({ id: "intl-msg:budgets.kanban.budgetNumber" })}: {budget.number}</span>
            <span className="text-size-14 text-gray-600">v{budget.lastVersionNumber?.toString()}</span>
          </div>

          <div className="space-y-2 mb-3">
            <div className="flex justify-between">
              <span className="text-size-14">{intl.formatMessage({ id: "intl-msg:budgets.kanban.recipient" })}:</span>
              <span className="text-size-14 truncate">{budget.recipientLabel}</span>
            </div>
            <div className="flex justify-between">
              <span className="text-size-14">{intl.formatMessage({ id: "intl-msg:budgets.kanban.date" })}:</span>
              <span className="text-size-14 truncate">{budget.updatedAt ? formatDateTimeWithTimezone(budget.updatedAt) : "-"}</span>
            </div>
            <div className="flex justify-between">
              <span className="text-size-14">{intl.formatMessage({ id: "intl-msg:budgets.kanban.chassis" })}:</span>
              <span className="text-size-14 truncate">{budget.vehicleChassis}</span>
            </div>
            <div className="flex justify-between">
              <span className="text-size-14">{intl.formatMessage({ id: "intl-msg:budgets.kanban.customer" })}:</span>
              <span className="text-size-14 truncate">{budget.customerName}</span>
            </div>
          </div>
        </div>

        <div className="flex flex-col mt-4">
          <button
            type="button"
            onClick={(e) => {
              e.stopPropagation();
              onViewVersions?.(budget);
            }}
            className="text-size-14 text-blue-600 hover:text-blue-800 underline mb-2 text-left truncate"
          >
            {intl.formatMessage({ id: "intl-msg:budgets.kanban.viewHistory" })}
          </button>
          <div
            className={`bg-[#FFFFFF] w-full text-center py-1.5 rounded-full font-medium truncate px-4 ${styles.buttonBg} ${styles.buttonText} transition-colors duration-200`}
            style={buttonBackgroundColor ? { backgroundColor: buttonBackgroundColor } : undefined}
          >
            {budget.statusLabel}
          </div>
        </div>
      </div>
    </div>
  );
};

export default BudgetKanbanCard;



